import Color from 'color';
import styled, {css} from 'styled-components';

import IconSvg from '@yourcoach/shared/assets/icons/secondary/Arrow - Down 2.svg';
import {ms} from '@yourcoach/shared/styles/normalizeSize';
import {getColor} from '@yourcoach/shared/styles/utils';
import {getFontWeight} from '@yourcoach/shared/styles/utils/getFontWeight';
import {Clickable} from '@yourcoach/shared/uikit/Clickable';
import {Image} from '@yourcoach/shared/uikit/Image';
import {Text} from '@yourcoach/shared/uikit/Text';
import {View} from '@yourcoach/shared/uikit/View';
import {platform} from '@yourcoach/shared/utils/platform';

export const Icon = styled(IconSvg).attrs(_p => ({
  fill: getColor('icon3')(_p),
}))`
  margin-left: ${ms(12)};
  width: ${ms(24)};
  height: ${ms(24)};
  min-height: 24px;
  min-width: 24px;
`;

export const Container = styled(Clickable)`
  position: relative;
  padding-right: ${ms(16)};
  display: flex;
  align-items: center;
  cursor: pointer;
  background-color: ${getColor('background1')};
  border: 1px solid ${getColor('border1')};
  border-radius: ${ms(20)};
  box-shadow: 0 ${ms(4)} ${ms(20)}
    ${p => Color(getColor('global2')(p)).alpha(0.05).toString()};

  ${platform.isWeb &&
  css`
    &:hover {
      box-shadow: none;
      ${Icon} {
        fill: ${getColor('icon4')};
      }
    }
  `}
`;

export const AvatarContainer = styled(View)`
  height: 40px;
  width: 40px;
  min-height: 40px;
  min-width: 40px;
  display: inline-block;
`;

export const Avatar = styled(Image)`
  width: 100%;
  height: 100%;
  border-radius: 50%;
`;

export const UseNameContainer = styled(Text)`
  max-width: ${ms(150)};
  margin-left: ${ms(8)};
  font-weight: ${getFontWeight('semibold')};
  font-size: 0.875rem;
  line-height: ${ms(20)};
  color: ${getColor('text1')};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
